<template>
  <div>
    <el-button type="primary" @click="returna">返回</el-button>
    <div class="new_msg_box">
      <div class="new_msg_row">
        <div class="new_msg_item">
          <span>灌片</span>
          <div>{{ infoData.pieceId }}</div>
        </div>
        <div class="new_msg_item">
          <span>灌片名称</span>
          <div>{{ infoData.pieceName }}</div>
        </div>
      </div>
      <div class="new_msg_row">
        <div class="new_msg_item">
          <span>调水量</span>
          <div>{{ infoData.amount }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { irrigationplanget } from "../../../../api/irrigated";
export default {
  name: "showmore",
  data() {
    return {
      titleshow: "",
      infoData: {},
    };
  },
  props: {
    id: {
      type: Number,
      required: true,
      default: "",
    },
    irrid: {
      type: Number,
      required: true,
      default: "",
    },
  },
  created() {
    // console.log(ids);
  },
  mounted() {
    this.getdelis();
  },
  methods: {
    async getdelis() {
      let res = await irrigationplanget(this.id, this.irrid);
      console.log(res);
      this.infoData = res.body.details;
    },
    returna() {
      this.$emit("closeshowdelise");
    },
  },
};
</script>

<style lang="scss" scoped></style>
